import React from 'react';

const Comp2 = (props) => {
    return (
        <div class="sec">
            <h1 class="head head_2">2</h1>
            <div class="sec_2"></div>
        </div>
    )
}

export default Comp2;